import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const Event: React.FC = () => (
  <div className={styles.event}>
    <div>
      <Skeleton variant="rect" height="48px" />
    </div>

    <div className={styles.eventInformation}>
      <Skeleton variant="rect" height="18px" />
    </div>
  </div>
);

const Group: React.FC = () => (
  <div className={styles.group}>
    <Skeleton variant="rect" height="45px" />

    <div className={styles.groupInformation}>
      <Skeleton variant="rect" height="18px" />
    </div>

    <Event />
    <Event />
    <Event />
  </div>
);

const GroupedTemplatePanelsLoadingState: React.FC = () => (
  <LoadingStateWrapper>
    <Group />
    <Group />
  </LoadingStateWrapper>
);

export default GroupedTemplatePanelsLoadingState;
